import { useNavigate } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { accountService } from "../../_services/accounts.service";
import { UserProfileCurrentForm } from "./userProfile-currentForm";
import { UserProfileInformationNoteList } from "./userProfile-informationNoteList";
import { UserProfileCompetitionLicenseList } from "./userProfile-competitionLicenseList";


export function UserProfileCompetitionLicenseIndex(params: { isMinor: boolean }) {
    const navigate = useNavigate();
    return (
        <>
            <UserProfileCurrentForm currentForm={params.isMinor ? FormTemplateTypeEnum.MinorEntrant : FormTemplateTypeEnum.CompetitionLicenceApplication} />
            <UserProfileCompetitionLicenseList isMinor={params.isMinor} />

            {accountService.isAdmin &&
                <div style={{ marginTop: "30px" }}>
                    <UserProfileInformationNoteList />
                </div>
            }
        </>
    );
}